import { useState, useEffect } from "react";
import "./invoice.css";
import Axios from "axios";
import Select from "react-select";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import swal from "sweetalert";

function Invoice() {
  const [data, setData] = useState([]);
  const [listorderid, setListOrderId] = useState([]);
  const [selectedorderid, setSelectedOrderId] = useState(null);
  const [invoiceData, setInvoiceData] = useState([]);
  const [selectedtitle, setSelectedTitle] = useState(null);
  const [titleOptions, setTitleOptions] = useState([]);
  const [selectedSku, setSelectedSku] = useState(null);
  const [selectedTitlesData, setSelectedTitlesData] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [quantityData, setQuantityData] = useState({});
  const [priceData, setPriceData] = useState({});
  const [challanno, setchallanno] = useState("");
  const [invoiceno, setinvoiceno] = useState("");
  const [selectedGST, setSelectedGST] = useState(null);
  const [InvFile, setInvFile] = useState();

  useEffect(() => {
    Axios.get("https://nodei.ssccglpinnacle.com/getOrder").then((response) => {
      setData(response.data);

      const orderIds = response.data.map((item) => ({
        value: item.orderid,
        label: item.orderid,
      }));
      setListOrderId(orderIds);
    });
  }, []);

  const handleSubmit = async () => {
    if (
      !selectedorderid ||
      !selectedDate ||
      !invoiceno ||
      !selectedGST ||
      !selectedTitlesData.length ||
      Object.values(quantityData).some((quantity) => quantity === 0) ||
      Object.values(priceData).some((price) => price === 0)
    ) {
      swal({
        title: "Error",
        text: "All fields are required.",
        icon: "error",
      });
      return;
    }
    try {
      const formData = new FormData();
      formData.append("orderid", selectedorderid.value);
      formData.append("Date", selectedDate);
      formData.append("InvFile", InvFile);
      formData.append("challanno", challanno);
      formData.append("invoiceno", invoiceno);

      formData.append(
        "Entries",
        JSON.stringify(
          selectedTitlesData.flatMap((selectedTitle) =>
            selectedTitle.data.map((row) => ({
              SKU: row.sku,
              Title: row.title,
              Edition: row.edition,
              Medium: row.Medium,
              orderquantity: row.approvedquantity,
              printquantity: quantityData[row.sku] || 0,
              printprice: priceData[row.sku] || 0,
              amount: (quantityData[row.sku] || 0) * (priceData[row.sku] || 0),
              gst: selectedGST ? selectedGST.value : null,
              GstValue: selectedGST
                ? calculateGST(
                    quantityData[row.sku] || 0,
                    priceData[row.sku] || 0,
                    selectedGST.value
                  ).toFixed(2)
                : null,
              totalAmountWithGST: calculateTotalPrice(
                quantityData[row.sku] || 0,
                priceData[row.sku] || 0,
                selectedGST.value
              ),
            }))
          )
        )
      );

      formData.append("Totalamount", calculateTotalAmount());

      const response = await Axios.post(
        "https://nodei.ssccglpinnacle.com/createInvoicevendor",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 201) {
        console.log("Data submitted successfully:", response.data);
        swal({
          title: "Success",
          text: "Data saved successfully!",
          icon: "success",
        }).then(() => {
          window.location.reload();
        });
      } else {
        console.error("Unexpected response:", response);
        throw new Error(
          `Failed to create invoice. Unexpected response: ${response.status}`
        );
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      swal({
        title: "Error",
        text: `Failed to create invoice. Please try again. ${error.message}`,
        icon: "error",
      });
    }
  };

  useEffect(() => {
    if (selectedorderid) {
      const selectedOrderData = data.find(
        (item) => item.orderid === selectedorderid.value
      );
      const uniqueTitles = selectedOrderData.updatedQuantity.reduce(
        (titles, entry) => {
          const key = `${entry.title}-${entry.sku}`;
          if (!titles.has(key)) {
            titles.set(key, { title: entry.title, sku: entry.sku });
          }
          return titles;
        },
        new Map()
      );

      const updatedTitleOptions = Array.from(uniqueTitles.values()).map(
        ({ title, sku }) => ({
          value: sku,
          label: `${title} - ${sku}`,
        })
      );
      setTitleOptions(updatedTitleOptions);
    } else {
      setTitleOptions([]);
    }
  }, [selectedorderid, data]);

  const handleOrderIdChange = (selectedOption) => {
    setSelectedOrderId(selectedOption);
    setSelectedTitle(null);
    setInvoiceData(selectedOption ? Array(1).fill({}) : []);
    setSelectedTitlesData([]);
    setQuantityData({});
    setPriceData({});
    setSelectedDate("");
    setchallanno("");
    setinvoiceno("");
  };

  const handletitleChange = (selectedOption) => {
    setSelectedTitle(selectedOption);
    setSelectedSku(selectedOption ? selectedOption.value : null);

    const isTitleAlreadySelected = selectedTitlesData.some(
      (titleData) => titleData.title === selectedOption.label
    );

    if (isTitleAlreadySelected) {
      swal({
        title: "Error",
        text: "Title has already been selected.",
        icon: "error",
      });
      setSelectedTitle(null);
      return;
    }

    if (selectedOption) {
      const selectedOrderData = data.find(
        (item) => item.orderid === selectedorderid.value
      );

      const filteredData = selectedOrderData.updatedQuantity.filter(
        (entry) => entry.sku === selectedOption.value
      );

      const selectedTitleData = {
        title: selectedOption.label,
        data: filteredData,
      };

      setSelectedTitlesData((prevData) => [...prevData, selectedTitleData]);
    }
  };

  useEffect(() => {
    if (selectedSku && selectedorderid) {
      const selectedOrderData = data.find(
        (item) => item.orderid === selectedorderid.value
      );

      const filteredData = selectedOrderData.updatedQuantity.filter(
        (entry) => entry.sku === selectedSku
      );

      setInvoiceData(filteredData);
    } else {
      setInvoiceData([]);
    }
  }, [selectedSku, selectedorderid, data]);

  const handleDelete = (sku) => {
    const updatedSelectedTitlesData = selectedTitlesData.map(
      (selectedTitle) => ({
        ...selectedTitle,
        data: selectedTitle.data.filter((row) => row.sku !== sku),
      })
    );

    setSelectedTitlesData(updatedSelectedTitlesData);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleQuantityChange = (event, sku) => {
    const newQuantityData = {
      ...quantityData,
      [sku]: parseInt(event.target.value, 10) || 0,
    };
    setQuantityData(newQuantityData);
  };

  const handlePriceChange = (event, sku) => {
    const newPriceData = {
      ...priceData,
      [sku]: parseFloat(event.target.value) || 0,
    };
    setPriceData(newPriceData);
  };

  const handleChallanNoChange = (event) => {
    setchallanno(event.target.value);
  };

  const handleInvoiceNoChange = (event) => {
    setinvoiceno(event.target.value);
  };

  const calculateTotalPrice = (quantity, price, gst) => {
    const priceWithoutGST = quantity * price;
    const gstAmount = (priceWithoutGST * gst) / 100;
    const totalPrice = priceWithoutGST + gstAmount;
    return totalPrice;
  };

  const calculateTotalAmount = () => {
    let totalAmount = 0;

    selectedTitlesData.forEach((selectedTitle) => {
      selectedTitle.data.forEach((row) => {
        const quantity = quantityData[row.sku] || 0;
        const price = priceData[row.sku] || 0;
        const gst = selectedGST ? selectedGST.value : 0;
        const priceWithoutGST = quantity * price;
        const gstAmount = (priceWithoutGST * gst) / 100;
        const rowTotal = priceWithoutGST + gstAmount;
        totalAmount += rowTotal;
      });
    });
    return totalAmount;
  };

  const calculateGST = (quantity, price, gst) => {
    const priceWithoutGST = quantity * price;
    const gstAmount = (priceWithoutGST * gst) / 100;
    return gstAmount;
  };

  return (
    <div className="invoivendor">
      <h5 style={{ textAlign: "center" }}>Invoice</h5>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          background: "#fff",
          padding: "18px 20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          marginBottom: "20px",
        }}
      >
        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
          <div
            style={{
              flex: "1 1 220px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <label
              style={{
                fontSize: "13px",
                marginBottom: "6px",
                color: "#444",
                fontWeight: 500,
              }}
            >
              Order ID
            </label>
            <Select
              name="orderid"
              value={selectedorderid}
              options={listorderid}
              onChange={handleOrderIdChange}
              isSearchable={true}
              placeholder="Select Order ID"
              styles={{
                control: (base) => ({
                  ...base,
                  borderRadius: "8px",
                  borderColor: "#ddd",
                  boxShadow: "none",
                  minHeight: "38px",
                  "&:hover": { borderColor: "#007bff" },
                }),
              }}
            />
          </div>

          <div
            style={{
              flex: "1 1 180px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <label
              style={{
                fontSize: "13px",
                marginBottom: "6px",
                color: "#444",
                fontWeight: 500,
              }}
            >
              Date
            </label>
            <input
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              style={{
                padding: "8px 12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                fontSize: "14px",
                minHeight: "38px",
                outline: "none",
                transition: "0.2s",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#007bff")}
              onBlur={(e) => (e.target.style.borderColor = "#ddd")}
            />
          </div>
        </div>

        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
          <div
            style={{
              flex: "1 1 220px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <label
              style={{
                fontSize: "13px",
                marginBottom: "6px",
                color: "#444",
                fontWeight: 500,
              }}
            >
              Title
            </label>
            <Select
              name="title"
              value={selectedtitle}
              options={titleOptions}
              onChange={handletitleChange}
              isSearchable={true}
              placeholder="Select Title"
              styles={{
                control: (base) => ({
                  ...base,
                  borderRadius: "8px",
                  borderColor: "#ddd",
                  boxShadow: "none",
                  minHeight: "38px",
                  "&:hover": { borderColor: "#007bff" },
                }),
              }}
            />
          </div>

          <div
            style={{
              flex: "1 1 150px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <label
              style={{
                fontSize: "13px",
                marginBottom: "6px",
                color: "#444",
                fontWeight: 500,
              }}
            >
              GST
            </label>
            <Select
              name="gst"
              value={selectedGST}
              options={[
                { value: 0, label: "0%" },
                { value: 12, label: "12%" },
                { value: 18, label: "18%" },
              ]}
              onChange={(selectedOption) => setSelectedGST(selectedOption)}
              isSearchable={true}
              placeholder="Select GST"
              styles={{
                control: (base) => ({
                  ...base,
                  borderRadius: "8px",
                  borderColor: "#ddd",
                  boxShadow: "none",
                  minHeight: "38px",
                  "&:hover": { borderColor: "#007bff" },
                }),
              }}
            />
          </div>
        </div>
      </div>

      <div style={{ width: "100%", overflowX: "auto" }}>
        <Table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            textAlign: "center",
            whiteSpace: "nowrap",
          }}
        >
          <thead>
            <tr>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                Title
              </th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                Medium
              </th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                Edition
              </th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>SKU</th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                Order Quantity
              </th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                Printed Quantity
              </th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                Printing Price
              </th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                Amount
              </th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                GST Value
              </th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                Amount + GST
              </th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {selectedTitlesData.map((selectedTitle, index) =>
              selectedTitle.data.map((row, rowIndex) => (
                <tr key={`${index}-${rowIndex}`}>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      maxWidth: "250px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={row.title}
                  >
                    {row.title}
                  </td>

                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    {row.Medium}
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    {row.edition}
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    {row.sku}
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    {row.approvedquantity}
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    <input
                      type="number"
                      style={{ width: "80px", textAlign: "center" }}
                      value={
                        quantityData[row.sku] !== undefined &&
                        quantityData[row.sku] !== 0
                          ? quantityData[row.sku]
                          : ""
                      }
                      onChange={(event) => handleQuantityChange(event, row.sku)}
                    />
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    <input
                      type="number"
                      style={{ width: "80px", textAlign: "center" }}
                      value={
                        priceData[row.sku] !== undefined &&
                        priceData[row.sku] !== 0
                          ? priceData[row.sku]
                          : ""
                      }
                      onChange={(event) => handlePriceChange(event, row.sku)}
                    />
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    {(quantityData[row.sku] || 0) * (priceData[row.sku] || 0)}
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    {selectedGST &&
                      calculateGST(
                        quantityData[row.sku] || 0,
                        priceData[row.sku] || 0,
                        selectedGST.value
                      ).toFixed(2)}
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    {selectedGST &&
                      calculateTotalPrice(
                        quantityData[row.sku] || 0,
                        priceData[row.sku] || 0,
                        selectedGST.value
                      ).toFixed(2)}
                  </td>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    <button
                      type="button"
                      style={{
                        padding: "6px 14px",
                        cursor: "pointer",
                        backgroundColor: "#e74c3c",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        fontWeight: "bold",
                        transition: "0.3s ease",
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = "#c0392b")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = "#e74c3c")
                      }
                      onClick={() => handleDelete(row.sku)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      <div
        style={{
          marginTop: "15px",
          padding: "12px 20px",
          backgroundColor: "#f4f6f9",
          border: "1px solid #ddd",
          borderRadius: "8px",
          fontSize: "16px",
          fontWeight: "bold",
          color: "#2c3e50",
          textAlign: "left",
          boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        Total Amount :{" "}
        <span style={{ color: "#27ae60" }}>
          {calculateTotalAmount().toFixed(2)}
        </span>
      </div>

      <form
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          marginTop: "10px",
          fontSize: "15px",
          color: "#333",
        }}
      >
        <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          Your Challan No (Tally)
          <input
            type="number"
            value={challanno}
            onChange={handleChallanNoChange}
            style={{
              padding: "5px 8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontSize: "14px",
              width: "130px",
            }}
          />
        </label>

        <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          Your Invoice No (Tally)
          <input
            type="number"
            value={invoiceno}
            onChange={handleInvoiceNoChange}
            style={{
              padding: "5px 8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontSize: "14px",
              width: "130px",
            }}
          />
        </label>
      </form>

      <label>
        Upload Invoice :
        <input
          id="filerChal"
          type="file"
          name="file1"
          onChange={(e) => setInvFile(e.target.files[0])}
        />
      </label>

      <div
        style={{
          padding: "8px 20px",

          color: "#fff",
          border: "none",
          borderRadius: "6px",
          fontSize: "15px",
          fontWeight: "600",
          cursor: "pointer",
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          transition: "0.3s ease",
          textAlign: "center",
        }}
      >
        <Button onClick={handleSubmit}>Submit</Button>
      </div>
    </div>
  );
}

export default Invoice;
